<h1 class="_white cell shrink decisionHeader"[i18nKey]="'decisions.period.completion.mainBlock.title'"></h1>

<kiwi-spacer [size]="32"></kiwi-spacer>

<div class="cell auto grid-y tabsDecisionContainer">
    <kiwi-tabs class="cell shrink tabsDecision" *ngIf="tabs" [tabs]="tabs | async"></kiwi-tabs>
    <router-outlet></router-outlet>
</div>
